let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5wtJS")).then(() => parcelRequire('dL6Om'));